// extracted by mini-css-extract-plugin
export var headerCell = "_4q-1";
export var loadingSpinnerContainer = "_4q-4";
export var loadingStateCell = "_4q-5";
export var rowWrapper = "_4q-3";
export var standaloneTable = "_4q-6";
export var table = "_4q-0";
export var white = "_4q-2";